export default __webpack_public_path__ + "static/media/zmogs.493daa77.webp";